module.exports = __webpack_public_path__ + "img/bg_banner2.d6c01e5a.png";